import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAdmin } from "../contexts/AdminContext";

const ProtectedRoute = ({ children }) => {
  const { authenticated, loading } = useAdmin();
  const location = useLocation();
  if (loading) {
    return (
      <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", color: "#5F5A72" }}>
        Verificando sesión…
      </div>
    );
  }
  if (!authenticated) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }
  return children;
};

export default ProtectedRoute;
